<template>
  <div class="home full-height">
    <v-row no-gutters class="full-height">
      <v-col cols="9" class="full-height">
        <div class="mapSheet full-height">
          <!-- @GmapMap the google Map -->
          <GmapMap
            :center="center"
            :zoom="13"
            ref="map"
            style="width: 100%; height: 100%;"
          >
            <div v-if="!groupBy">
              <gmap-marker
                v-for="(m, j) in markers"
                :key="j + 'map'"
                :position="m.position"
                :label="m.label"
                :icon="m.icon"
                @click="openWindow(j)"
              ></gmap-marker>
            </div>
            <gmap-info-window
              v-for="(m, index) in markers"
              :key="index"
              @closeclick="m.window=false"
              :opened="m.window"
              :position="m.position"
              :options="{
              pixelOffset: {
                width: 10,
                height: -5
              }
            }"
            >
              <v-list>
                 <span style=" font-weight: bolder">{{m.name}}</span>
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title v-text="'Letztes Update: ' + m.date"></v-list-item-title>
                    <v-list-item-title v-if="m.moving === 0" v-text="'Zustand: Nicht in Bewegung'"></v-list-item-title>
                    <v-list-item-title v-if="m.moving === 1" v-text="'Zustand: In Bewegung'"></v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
             </v-list>
            </gmap-info-window>
            <gmap-cluster v-if="groupBy" :calculator="calculator" :styles="grid" :zoomOnClick="true">
              <GmapMarker
                :key="'marker-' + index"
                v-for="(m, index) in markers"
                :position="m.position"
                :label="m.label"
                :icon="m.icon"
                @click="openWindow(index)"
                :clickable="true"
              />
            </gmap-cluster>
          </GmapMap>
        </div>
      </v-col>

      <v-col cols="3" class="full-height">
        <div class="sidebar full-height">
          <v-sheet
            color="white"
            light
            tile
            class="pt-4 pl-2 pr-6 full-height"
           >
            <v-row>
              <v-col cols="6">
                <v-text-field
                  v-model="search"
                  label="Suchen..."
                  clearable
                  class="search"
                ></v-text-field>
              </v-col>

              <v-col cols="6">
                <v-select :items="orders" v-model="sortBy" label="Sortieren nach:" />
              </v-col>
            </v-row>
            
            <div class="cardList">
              <v-card
                v-for="(gps) in gpsList"
                :key="gps.id">
                <v-card-title>
                  <v-btn @click="goToMarker(gps, gps.id)" depressed><span class="title fontt-weight-light">{{gps.name}}</span></v-btn>
                </v-card-title>
                <v-card-text v-if="gps.moving === 0"><span style=" font-weight: bolder">Letztes Update:</span> {{gps.date}}<br>
                                                  <span style=" font-weight: bolder">Zustand:</span> Nicht in Bewegung</v-card-text>
                <v-card-text v-else><span style=" font-weight: bolder">Letztes Update:</span> {{gps.date}}<br>
                                    <span style=" font-weight: bolder">Zustand:</span> In Bewegung</v-card-text>
              </v-card>
            </div>
          </v-sheet>
        </div>
      </v-col>
    </v-row>

    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { gmapApi } from 'vue2-google-maps';
import axios from 'axios';
import { searchObjects } from 'libj-object-search';
import moment from 'moment';
import equal from 'deep-equal';
/**
 * Google map application containg the asset tracking
 */
export default {
  name: 'Home',
  data() {
    return {
      search: '',
      center: {
        lat:50.110924,
        lng:8.682127
      },
      gps: [],
      markers: [],
      interval: null,
      grid: [],
      gridIndex: {},
      sortBy: {
        key: 'name',
        dir: 1
      },
      orders: [
        {
          text: 'Name (Aufsteigend)',
          value: {
            key: 'name',
            dir: 1
          }
        },
        {
          text: 'Name (Absteigend)',
          value: {
            key: 'name',
            dir: -1
          }
        },
        {
          text: 'Datum (Aufsteigend)',
          value: {
            key: 'date',
            dir: 1
          }
        },
        {
          text: 'Datum (Absteigend)',
          value: {
            key: 'date',
            dir: -1
          }
        }
      ]
    };
  },
  async mounted() {
    this.generateGrid();

    await this.$refs.map.$mapPromise;
    await this.getGps();
    window.setTimeout(() => {
      this.setCenter();
    }, 500);

    await this.waitForUserLogin();

    if (this.interval === null) {
      this.interval = window.setInterval(async () => {
        await this.getGps();
      }, 10000);
    }
  },
  computed: {
    ...mapGetters(['user', 'groupBy']),
    google: gmapApi,
    overlay() {
      return false;
    },
    /**
     * Search function to find an gps in the search bar
     * @public
     * @return the found gps or an empty array if not found
     */
    gpsList() {
      if (this.gps) {
        let g = searchObjects(this.search || '', this.gps);

        g.sort((a, b) => {
          if (a[this.sortBy.key] > b[this.sortBy.key]) {
            return this.sortBy.dir;
          }

          if (a[this.sortBy.key] < b[this.sortBy.key]) {
            return this.sortBy.dir * -1;
          }

          return 0;
        });

        return g;
      }

      return [];
    },
  },
  methods: {
    /**
     * Generates a list of grid icons for use with google-maps-cluster
     * 
     * @public
     * @return {undefined}
      */
    generateGrid() {
      this.grid = [];
      this.gridIndex = {};
      let index = 0;

      for (let i = 0; i <= 100; i += 20) {
        for (let j = 0; j <= 100; j += 20) {
          this.grid.push({
            textColor: 'black',
            url: `https://graph.mainova.digital/?data=${i};${j};0`,
            height: 48,
            width: 48
          });

          this.gridIndex[`${i};${j}`] = index;

          index++;
        }
      }
    },
    /**
     * Calculates the marker index used for google-maps-cluster
     * 
     * @param {Array} markers All visible google maps markers
     * @public
     * @return {Object} Current Cluster with text lable and icon index
      */
    calculator(markers) {
      let green = Math.ceil((markers.filter(e => !e.icon.moving).length / markers.length * 100) / 20) * 20;
      let yellow = Math.ceil((markers.filter(e => e.icon.moving).length / markers.length * 100) / 20) * 20;

      let index = `${green};${yellow}`;

      return {
        text: markers.length.toString(),
        index: this.gridIndex[index] + 1,
        title: ''
      };
    },
    /**
     * Go to the seelcted marker
     * @param {Object} gps The current gps marker
     * @param {Int} id The current gps marker id
     * @public
     * @return
      */
    goToMarker(gps, id) {
      this.$refs.map.center.lat = gps.lat;
      this.$refs.map.center.lng = gps.lng;

      this.center.lat = gps.lat;
      this.center.lng = gps.lng;

      this.$refs.map.$mapObject.setZoom(20);

      for (let i = 0; i < this.markers.length; i++ ) {
        if (this.markers[i].id === id) {
          this.markers[i].window = true;
        } else {
          this.markers[i].window = false;
        }
      }

    },
    /**
     * Open the popup window of an marker / gps tracker on the map
     * @public
     * @return
     */
    openWindow(index) {
      this.markers.forEach(e => e.window = false);
      this.markers[index].window = true;
    },
    /**
     * Get all the gps tracker
     * @public
     * @return
     */
    async getGps() {
      let gps = [];

      try {
        // let re = await axios(`${config.authServer}/api/gps/getGPS`);
        let res = await axios(`/api/gps/getGPS`);
        if (res.data) {
          gps = res.data;
        for (let i = 0; i < gps.length; i++) {
          if (gps[i].date !== null) {
            let tmp = gps[i].date;
            gps[i].date = moment(tmp).format('DD.MM.YYYY HH:mm');
        }
      }
        }
      } catch (_) {
        //
      }

      if (!this.gps || !equal(this.gps, gps)) {
        this.gps = gps;
        this.addMarker();
      }
    },
    /**
     * Add all the gps tracker to the google map
     * @public
     * @return
    */
    addMarker() {
      this.markers = [];

      let icon;
      for (let i = 0; i < this.gps.length; i++) {
        if (this.gps[i].moving === 1) {
          icon = {
            path: 'M0,5a5,5 0 1,0 10,0a5,5 0 1,0 -10,0',
            fillColor: '#fcba03',
            fillOpacity: 1,
            strokeWeight: 0,
            moving: true,
            scale: 2,
            labelOrigin: new this.google.maps.Point(4, 15)
          };
        } else {
          icon = {
            path: 'M0,5a5,5 0 1,0 10,0a5,5 0 1,0 -10,0',
            fillColor: '#0c821a',
            fillOpacity: 1,
            strokeWeight: 0,
            moving: false,
            scale: 2,
            labelOrigin: new this.google.maps.Point(4, 15)
          };
        }
        let lat = this.gps[i].lat;
        let lng = this.gps[i].lng;
        this.addSingleMarker(lat, lng, icon, this.gps[i].name, this.gps[i].date, this.gps[i].moving, this.gps[i].id);
      }
    },
    /**
     * Add a single tracker to markers
     * @public
     * @param {String} lat Latitude of the marker
     * @param {String} lng Longitude of the marker
     * @param {Object} icon The icon for gps
     * @param {String} label The name of the gps tracker for the label
     * @param {Date} date The date and timestemp the last time the data was updated
     * @param {Boolean} moving The current state of an gps
     * @param {Int} id The id of the gps tracker
     * @return
     */
    addSingleMarker(lat, lng, icon, label, date, moving, id) {
      const marker = {
        position: {
          lat: lat,
          lng: lng
        },
        icon,
        label: {
          text: label,
          color: 'black',
          fontWeight: 'bold'
        },
        name: label,
        date: date,
        window: false,
        moving: moving,
        id: id
      };

      this.markers.push(marker);
    },
    /**
     * Set the center of the google map
     * @public
     */
    setCenter() {
      const bounds = new this.google.maps.LatLngBounds();

      for (let m of this.markers) {
        bounds.extend(m.position);
      }

      this.$refs.map.fitBounds(bounds, 70);

      if (this.markers.length === 1) {
        this.$refs.map.zoom = 14;

        this.$nextTick(() => {
          this.$refs.map.$mapObject.setZoom(this.$refs.map.$mapObject.getZoom() - 3);
        });
      }

    },
    /**
     * Checks if user is logged in
     * @returns {Promise} done
     */
    waitForUserLogin() {
      return new Promise((done) => {
        let ask = () => {
          if (this.user !== null) {
            return done();
          } else {
            window.setTimeout(ask, 100);
          }
        };

        ask();
      });
    }
  }
};
</script>


<style lang="scss" scoped>
.full-height {
  position: relative;
  height: calc(100vh - 64px);
  width: 100%;
}

.search {
  margin-left: 10px;
  margin-bottom: -10px;
}

.cardList {
  position: relative;
  height: calc(100% - 64px);
  overflow: auto;
}

.home {
  margin-top: 0px;
}
</style>
